import React from 'react'
import Bounce from 'react-reveal/Bounce'
function OptionsModal(props) {
    const themeColors = props.themeColors
    const darkMode = props.darkMode
    return (
        <div style={{ display: 'flex', position: 'fixed', left: 10, right: 10, bottom: 10, flexDirection: 'column', color: darkMode ? 'black' : 'white', zIndex:10 }}>
            <Bounce delay={0} duration={500} bottom>
                <div style={{ display: 'flex', flex: 1, paddingLeft: 10, paddingRight: 10 }}>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', borderRadius: 10, backgroundColor: darkMode ? 'rgba(255, 255, 255, 1)' : 'rgba(191, 191, 191, 1)' }}>
                        <div style={{ flex: .5, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: 'solid .1px #f7f7f7', color: darkMode ? 'grey' : '#3d3d3d' }}><p>{props.link}</p></div>
                        <a href={props.link} target="_blank" style={{ textDecoration: 'none', color: 'inherit', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00acee' }}>
                            <div onClick={props.optCancel}><p>Open in new tab</p></div>
                        </a>
                    </div>
                </div>
                <div style={{ display: 'flex', flex: .2, padding: 10 }}>
                    <div onClick={props.optCancel} style={{ flex: 1, borderRadius: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'red', backgroundColor: darkMode ? 'rgba(255, 255, 255, 1)' : 'rgba(191, 191, 191, 1)', cursor: 'pointer' }}>
                        <p>Cancel</p>
                    </div>
                </div>
            </Bounce>
        </div>
    )
}

export default OptionsModal